<template>
  <v-tooltip bottom>
    <template #activator="{ on, attrs }">
      <v-btn icon :class="btnClass" :aria-label="rotulo" v-bind="attrs" v-on="on" @click="alternar">
        <v-icon :color="iconColor">{{ escuro ? "mdi-weather-sunny" : "mdi-weather-night" }}</v-icon>
      </v-btn>
    </template>
    <span>{{ rotulo }}</span>
  </v-tooltip>
</template>

<script>
import { definirTema } from "@/plugins/tema";

export default {
  name: "ETemaToggle",
  props: {
    iconColor: { type: String, default: undefined },
    btnClass: { type: [String, Array, Object], default: undefined },
  },
  computed: {
    escuro() {
      return this.$vuetify.theme.dark;
    },
    rotulo() {
      return this.escuro ? "Ativar modo claro" : "Ativar modo escuro";
    },
  },
  methods: {
    async alternar() {
      const novoTema = this.escuro ? "claro" : "escuro";
      definirTema(novoTema);

      if (!this.$services.authService.isLoggedIn()) return;
      try {
        await this.$services.authService.atualizarTema(novoTema);
      } catch (error) {
        // O tema já foi aplicado e salvo no navegador; a conta sincroniza na próxima troca.
        console.error("Erro ao salvar o tema na conta:", error);
      }
    },
  },
};
</script>
